<style>
ul,
li {
  margin: 0;
  padding: 0;
  border: 0;
  font-size: 100%;
  font: inherit;
  vertical-align: baseline;
}

ol,
ul {
  list-style: none;
}
a {
  text-decoration: none;
}

nav > ul {
  width: 350px;
}

nav ul li {
  position: relative;
}

nav ul li:hover > ul {
  opacity: 1;
}

nav ul li a {
  font-family: Arial, Helvetica, sans-serif;
  font-size: 24px;
  line-height: 1.5em;
  background-color: #3aa94c;
  color: #ffffff;
  display: block;
  height: 50px;
  line-height: 50px;
  text-align: center;
  width: 50px;
}

nav ul li a:after {
  background-color: #3aa94c;
  content: "";
  display: block;
  height: 8px;
  left: 46px;
  position: absolute;
  top: 21px;
  transform: rotate(45deg);
  -o-transform: rotate(45deg);
  -ms-transform: rotate(45deg);
  -moz-transform: rotate(45deg);
  -webkit-transform: rotate(45deg);
  width: 8px;
  z-index: 1;
}

nav ul li a:hover {
  color: #3aa94c;
}

nav ul li ul {
  display: block;
  left: 50px;
  position: absolute;
  top: 0;
  opacity: 1;
  transition: opacity 0.5s;
  -o-transition: opacity 0.5s;
  -moz-transition: opacity 0.5s;
  -webkit-transition: opacity 0.5s;
}

nav ul li ul li {
  float: left;
  margin-top: 0;
}

nav ul li ul li a {
  background-color: #fff;
  color: #b2ddb9;
  position: relative;
}

nav ul li ul li a:after {
  display: none;
}

.tooltip1:hover:before {
  background-color: #3aa94c;
  content: attr(data-tooltip1);
  color: #fff;
  display: block;
  font-size: 12px;
  height: 21px;
  line-height: 21px;
  padding: 0 10px;
  position: absolute;
  top: -18px;
  white-space: nowrap;
  z-index: 1;
  box-shadow: 0px 3px 10px #333;
}

.tooltip1:hover:after {
  background-color: #3aa94c;
  content: "";
  display: block;
  height: 8px;
  left: 50%;
  position: absolute;
  top: -1px;
  transform: rotate(45deg);
  -ms-transform: rotate(45deg);
  -moz-transform: rotate(45deg);
  -webkit-transform: rotate(45deg);
  width: 8px;
  z-index: 1;
}

.tooltip2:hover:before {
  background-color: #428bca;
  content: attr(data-tooltip1);
  color: #fff;
  display: block;
  font-size: 12px;
  height: 21px;
  line-height: 21px;
  padding: 0 10px;
  position: absolute;
  top: -5px;
  margin-left: -25px;
  white-space: nowrap;
  z-index: 1;
  box-shadow: 0px 3px 10px #333;
}

.tooltip2:hover:after {
  background-color: #428bca;
  content: "";
  display: block;
  height: 8px;
  margin-left: 5px;
  position: absolute;
  top: 12px;
  transform: rotate(45deg);
  -ms-transform: rotate(45deg);
  -moz-transform: rotate(45deg);
  -webkit-transform: rotate(45deg);
  width: 8px;
  z-index: 1;
}
</style>

<template>
  <footer class="container hidden-print v-footer">
    <div class="row">
      <div
        id="v-quickfooter"
        class="col-xs-7 tooltip-wrapper"
        style="margin-left: -15px;"
      >
        <nav>
          <ul>
            <li>
              <a href="#"
                ><span
                  class="fa fa-fw fa-link"
                  style="color: white !important;"
                ></span
              ></a>
              <ul class="clearfix">
                <li>
                  <router-link
                    :to="{ name: 'NewCustomer' }"
                    v-tooltip="{
                      content: 'Neuer Kunde',
                      classes: 'custom-tooltip'
                    }"
                    ><span class="fa fa-fw fa-user"></span
                  ></router-link>
                </li>

                <li>
                  <a
                    href="/venues/timetable/week/"
                    v-tooltip="{
                      content: 'Freie Zeiten',
                      classes: 'custom-tooltip'
                    }"
                    ><span class="fa fa-fw fa-clock-o"></span
                  ></a>
                </li>
                <li>
                  <a
                    href="/venues/scheduler/"
                    v-tooltip="{
                      content: 'Kalender',
                      classes: 'custom-tooltip'
                    }"
                    ><span class="fa fa-fw fa-calendar"></span
                  ></a>
                </li>

                <li>
                  <a
                    href="<?= \helper\Registry::get()->widgetUrl . (isset($_SESSION['partnerUrlCode']) && !empty($_SESSION['partnerUrlCode']) ? $_SESSION['partnerUrlCode'] : $_SESSION['partnerCode']) . '/' ?>"
                    target="_blank"
                    v-tooltip="{
                      content: 'Buchungswidget',
                      classes: 'custom-tooltip'
                    }"
                    ><span class="fa fa-fw fa-server"></span
                  ></a>
                </li>

                <li>
                  <a
                    href="https://handbuch.venuzle.at"
                    target="_blank"
                    v-tooltip="{
                      content: 'Online-Handbuch',
                      classes: 'custom-tooltip'
                    }"
                    ><span class="fa fa-fw fa-lightbulb-o"></span
                  ></a>
                </li>

                <li>
                  <a
                    @click="logOut"
                    class="pointer"
                    v-tooltip="{
                      content: 'Abmelden',
                      classes: 'custom-tooltip'
                    }"
                    ><span class="fa fa-fw fa-sign-out"></span
                  ></a>
                </li>
              </ul>
            </li>
          </ul>
        </nav>
      </div>

      <div
        class="col-xs-5 hidden-xs"
        style="margin-top: 15px;margin-bottom: 15px;"
      >
        <span class="pull-right">
          <img
            class="v-logo-footer pull-right"
            src="https://manager.venuzle.at/assets/images/vvm.footer.png"
            alt="VENUZLE"
          />
        </span>
      </div>
    </div>
  </footer>

  <!-- Scroll to top -->
  <!-- <span class="totop" style="display:none;"><a href="#"><i class="fa fa-chevron-up fa-2x"></i></a></span> -->

  <!-- <script src="https://manager.venuzle.at/assets/js/jquery.form.min.js"></script> -->
  <!-- <script src="https://manager.venuzle.at/assets/js/jquery.validate.min.js"></script> -->
  <!-- <script src="https://manager.venuzle.at/assets/js/jquery.modal.js"></script> -->

  <!--[if lt IE 10]>
    <script src="/assets/js/jquery.placeholder.min.js"></script>
  <![endif]-->
  <!--[if lt IE 9]>
    <script src="/assets/js/v-forms-ie8.js"></script>
  <![endif]-->

  <!-- // <script type="text/javascript">
//     $('.tooltip-wrapper').tooltip({
//         selector: "[data-toggle=tooltip]",
//         container: "body"
//     });
//
//     $('.popup-wrapper').popover({
//         selector: "[data-toggle=popover]",
//         container: "body",
//         trigger: "hover",
//         html: "true",
//         delay: {show: 0, hide: 0}
//     });
//
//     ;
//     (function ($, window, document, undefined)
//     {
//         $.fn.doubleTapToGo = function (params)
//         {
//             if (!('ontouchstart' in window) &&
//                     !navigator.msMaxTouchPoints &&
//                     !navigator.userAgent.toLowerCase().match(/windows phone os 7/i))
//                 return false;
//
//             this.each(function ()
//             {
//                 var curItem = false;
//
//                 $(this).on('click', function (e)
//                 {
//                     var item = $(this);
//                     if (item[ 0 ] != curItem[ 0 ])
//                     {
//                         e.preventDefault();
//                         curItem = item;
//                     }
//                 });
//
//                 $(document).on('click touchstart MSPointerDown', function (e)
//                 {
//                     var resetItem = true,
//                             parents = $(e.target).parents();
//
//                     for (var i = 0; i < parents.length; i++)
//                         if (parents[ i ] == curItem[ 0 ])
//                             resetItem = false;
//
//                     if (resetItem)
//                         curItem = false;
//                 });
//             });
//             return this;
//         };
//     })(jQuery, window, document);
// </script>
//
//
// <script type="text/javascript">
//     $('#v-menu li:has(ul)').doubleTapToGo();
// </script>
//
// <script type="text/javascript">
//     $("#mainMenu").headroom({});
// </script> -->

  <!-- </div> -->
</template>

<script>
export default {
  methods: {
    logOut() {
      localStorage.removeItem("partnerId");
      localStorage.removeItem("partnerCode");
      window.location.replace("/login");
    }
  }
};
</script>
